module.exports = __webpack_public_path__ + "img/map.12327293.svg";